/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S10_Li3_AInputs */

const tr_mesafeli_s10_li3_a = /** @type {(inputs: Mesafeli_S10_Li3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri bu anahtarları Platform içi`)
};

const en_mesafeli_s10_li3_a = /** @type {(inputs: Mesafeli_S10_Li3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Customer may at any time, from the Platform screen`)
};

const de_mesafeli_s10_li3_a = /** @type {(inputs: Mesafeli_S10_Li3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Kunde kann diese Schlüssel jederzeit über den Bildschirm der Plattform`)
};

const ru_mesafeli_s10_li3_a = /** @type {(inputs: Mesafeli_S10_Li3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Клиент может в любое время через экран Платформы`)
};

/**
* | output |
* | --- |
* | "The Customer may at any time, from the Platform screen" |
*
* @param {Mesafeli_S10_Li3_AInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s10_li3_a = /** @type {((inputs?: Mesafeli_S10_Li3_AInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S10_Li3_AInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s10_li3_a(inputs)
	if (locale === "de") return de_mesafeli_s10_li3_a(inputs)
	if (locale === "ru") return ru_mesafeli_s10_li3_a(inputs)
	return tr_mesafeli_s10_li3_a(inputs)
});